export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '昵称',
    dataIndex: 'user_nickname',
  },
  {
    title: '真实姓名',
    dataIndex: 'user_realname',
  },
  {
    title: '手机号',
    dataIndex: 'mobile',
  },
  {
    title: '积分',
    dataIndex: 'score',
  },
  {
    title: '关联企业',
    dataIndex: 'drugs_count',
    scopedSlots: { customRender: 'drugs_count' },
  },
  {
    title: '关联医生数量',
    dataIndex: 'doctors_count',
    scopedSlots: { customRender: 'doctors_count' },
  },
  {
    title: '完成任务数量',
    dataIndex: 'task_finish_count',
  },
  {
    title: '状态',
    dataIndex: 'status',
    customRender: (text, record, index)=>{
      return record.status===0?'禁用':'启用';
    },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'user_realname',
    lable: '真实姓名',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'user_nickname',
    lable: '昵称',
    lableCol: 4,
    wrapperCol: 18,
  },

  {
    name: 'sex',
    lable: '性别',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'address',
    lable: '地区',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'mobile',
    lable: '手机号',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'password',
    lable: '密码',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'introduction',
    lable: '个人简介',
    lableCol: 4,
    wrapperCol: 18,
  },
];